/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ProjectWellVsps,
  VspAttach,
  VspCreation,
  VspData,
  VspHeader,
  VspSection,
  VspTable,
} from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ProjectVspClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags ProjectVsp
   * @summary Добавить ВСП в проект
   * @request POST:/geology/project/{projectId}/vsp/add-vsp
   * @secure
   */
  projectVspAddVspToProject = (projectId: string, data: string[], params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/geology/project/${projectId}/vsp/add-vsp`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectVsp
   * @summary Создание ВСП в проекте
   * @request POST:/geology/project/{projectId}/vsp
   * @secure
   */
  projectVspAddVsp = (projectId: string, data: VspCreation, params: RequestParams = {}) =>
    this.http.request<string, string>({
      path: `/geology/project/${projectId}/vsp`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectVsp
   * @summary Получить список идентификаторов ВСП для проекта
   * @request GET:/geology/project/{projectId}/vsp
   * @secure
   */
  projectVspGetVspsForProject = (projectId: string, params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/geology/project/${projectId}/vsp`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectVsp
   * @summary Применить скоростной закон к скважинам
   * @request POST:/geology/project/{projectId}/vsp/attach-vsp
   * @secure
   */
  projectVspAttachVsp = (projectId: string, data: VspAttach, params: RequestParams = {}) =>
    this.http.request<string, string>({
      path: `/geology/project/${projectId}/vsp/attach-vsp`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectVsp
   * @summary Получить список идентифкаторов ВСП для скважины проекта
   * @request GET:/geology/project/{projectId}/vsp/well/{wellId}
   * @secure
   */
  projectVspGetVspsForWell = (projectId: string, wellId: string, params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/geology/project/${projectId}/vsp/well/${wellId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectVsp
   * @summary Получить список заголовков ВСП для скважины проекта
   * @request GET:/geology/project/{projectId}/vsp/well/{wellId}/head
   * @secure
   */
  projectVspGetVspsHeaderForWell = (
    projectId: string,
    wellId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<VspHeader[], any>({
      path: `/geology/project/${projectId}/vsp/well/${wellId}/head`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectVsp
   * @summary Получить список заголовков ВСП для проекта
   * @request GET:/geology/project/{projectId}/vsp/head
   * @secure
   */
  projectVspGetVspsHeaderForProject = (projectId: string, params: RequestParams = {}) =>
    this.http.request<VspHeader[], any>({
      path: `/geology/project/${projectId}/vsp/head`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectVsp
   * @summary Получить идентификатор активного ВСП для проектной скважины
   * @request GET:/geology/project/{projectId}/vsp/well/{wellId}/active-vsp
   * @secure
   */
  projectVspGetActiveVspForWell = (projectId: string, wellId: string, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/geology/project/${projectId}/vsp/well/${wellId}/active-vsp`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectVsp
   * @summary Получить заголовок активного ВСП для проектной скважины
   * @request GET:/geology/project/{projectId}/vsp/well/{wellId}/active-vsp/head
   * @secure
   */
  projectVspGetActiveVspHeaderForWell = (
    projectId: string,
    wellId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<VspHeader, any>({
      path: `/geology/project/${projectId}/vsp/well/${wellId}/active-vsp/head`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectVsp
   * @summary Получить данные ВСП
   * @request GET:/geology/project/{projectId}/vsp/{vspId}
   * @secure
   */
  projectVspGetVspData = (projectId: string, vspId: string, params: RequestParams = {}) =>
    this.http.request<VspData, any>({
      path: `/geology/project/${projectId}/vsp/${vspId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectVsp
   * @summary Получить срезку ВСП
   * @request GET:/geology/project/{projectId}/vsp/{vspId}/{attributeSectionName}
   * @secure
   */
  projectVspGetVspSection = (
    projectId: string,
    vspId: string,
    attributeSectionName: string,
    params: RequestParams = {},
  ) =>
    this.http.request<VspSection, any>({
      path: `/geology/project/${projectId}/vsp/${vspId}/${attributeSectionName}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectVsp
   * @summary Установить ВСП активным для заданной проектной скважины
   * @request PATCH:/geology/project/{projectId}/vsp/well/{wellId}/set-active/{vspId}
   * @secure
   */
  projectVspSetActiveVsp = (
    projectId: string,
    wellId: string,
    vspId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/geology/project/${projectId}/vsp/well/${wellId}/set-active/${vspId}`,
      method: 'PATCH',
      secure: true,
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectVsp
   * @summary Получить скважины с/без ВСП и сдвигом по проекту и месторождению
   * @request GET:/geology/project/{projectId}/vsp/field/{fieldId}
   * @secure
   */
  projectVspGetWellsWithVsp = (projectId: string, fieldId: string, params: RequestParams = {}) =>
    this.http.request<ProjectWellVsps[], any>({
      path: `/geology/project/${projectId}/vsp/field/${fieldId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectVsp
   * @summary Обновить сдвиг(дельта t) проектного ВСП
   * @request PUT:/geology/project/{projectId}/vsp/projectVsp/{projectVspId}
   * @secure
   */
  projectVspUpdateOffsetByProjectVsp = (
    projectVspId: string,
    projectId: string,
    query: {
      /**
       * Сдвиг(дельта t)
       * @format int32
       */
      offset: number
    },
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/geology/project/${projectId}/vsp/projectVsp/${projectVspId}`,
      method: 'PUT',
      query: query,
      secure: true,
      ...params,
    }) /**
 * No description
 * 
 * @tags ProjectVsp
 * @summary Удаление ВСП из проекта по набору ключей.
Вернёт количество реально удалённых ВСП.
 * @request PATCH:/geology/project/{projectId}/vsp/remove
 * @secure
 */
  projectVspRemoveVspsFromProject = (
    projectId: string,
    data: string[],
    params: RequestParams = {},
  ) =>
    this.http.request<number, any>({
      path: `/geology/project/${projectId}/vsp/remove`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectVsp
   * @summary Получить таблицу для ВСП проекта
   * @request GET:/geology/project/{projectId}/vsp/{vspId}/table
   * @secure
   */
  projectVspGetVspTable = (projectId: string, vspId: string, params: RequestParams = {}) =>
    this.http.request<VspTable, any>({
      path: `/geology/project/${projectId}/vsp/${vspId}/table`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
}
